module.exports = __webpack_public_path__ + "static/media/mmm-checkmark.fe098a72.svg";